import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { imageEndpoints } from '../../../../constants';

class ImagesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  remove = async (id: number) => {
    return this.#requestInstance.delete(imageEndpoints.getImageById(id));
  };

  create = async (input: FormData) => {
    return this.#requestInstance.post(imageEndpoints.postImage, input);
  };

  createMany = async (input: FormData) => {
    return this.#requestInstance.post(imageEndpoints.postImages, input);
  };

  updatePreview = async (id: number) => {
    return this.#requestInstance.patch(imageEndpoints.previewImage(id));
  };
}

export const imagesApi = new ImagesApi(axios);
